import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
} from '../../../sdk/UserSession.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../sdk/errors.mjs';
import {
  Projecto73xqbcrzskm as Project,
  LineItem2rt64afaiyloc as LineItem,
  ItemChangee3c665suy3yz as ItemChange,
  ContractorNote59o6kpmrrw5h as ContractorNote,
  Clientuccelyr89ch8 as Client,
  Contractor1wog4uk4l8u77 as Contractor,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  Dispute39kejofcwuxch as Dispute,
  ScopeView2pjeasrtqdymw as ScopeView,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  PayApplicationmbkdcq3ut87x as PayApplication,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  Incident3aojs8cp7629c as Incident,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
  IncidentMessageComment1adwwkgdgyo0h as IncidentMessageComment,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
  ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation,
  UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest,
  FundsRequesthksopls9wk01 as FundsRequest,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_project15zbqkhtwq5i6 as get_project } from '../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import {
  eq1298m2cje971u as eq,
  neqqjkp0prqcfuy as neq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_project1h3ocr37wkxs4 as get_project_0 } from '../../../../../../crowpay-shared/com/crowpay/ItemChangeFields.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { AdjustedLineItemjcq04uf63gb9 as AdjustedLineItem } from '../../../utils/AdjustedLineItem.mjs';
import {
  get_project34plxwa7097z4 as get_project_1,
  get_at1y0kiqq3vi1b7 as get_at,
} from '../../../../../../crowpay-shared/com/crowpay/ContractorNoteFields.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  Addresscpovxna1tjmg as Address,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  get_project33kl9j91bsmm2 as get_project_2,
  get_order3gxa8tjn23l9j as get_order,
} from '../../../../../../crowpay-shared/com/crowpay/PunchListItemFields.mjs';
import {
  get_projectgtrfvpc0zfzj as get_project_3,
  get_number1h0r9mzxgakil as get_number,
} from '../../../../../../crowpay-shared/com/crowpay/ChangeRequestFields.mjs';
import { get_project340dxjn5izj1d as get_project_4 } from '../../../../../../crowpay-shared/com/crowpay/DisputeFields.mjs';
import {
  get_project2bky694b9ef47 as get_project_5,
  get_order35z39a4v9znp3 as get_order_0,
  get_scopeTitle3b12utn8vsli8 as get_scopeTitle,
} from '../../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import { get_project1h2gisnyegd0y as get_project_6 } from '../../../../../../crowpay-shared/com/crowpay/PendingItemChangeFields.mjs';
import { get_projectgc591kstp7s4 as get_project_7 } from '../../../../../../crowpay-shared/com/crowpay/PendingLineItemFields.mjs';
import {
  get_project8eilj2kht5hl as get_project_8,
  get_number1dhanv5t6fc1y as get_number_0,
} from '../../../../../../crowpay-shared/com/crowpay/PayApplicationFields.mjs';
import {
  get_project2kz1aoxt3unwl as get_project_9,
  get_amount297a4togm1x48 as get_amount,
  get__id1xznbeynjgj8x as get__id,
} from '../../../../../../crowpay-shared/com/crowpay/PayAppItemFields.mjs';
import {
  get_project2hdo06n9xkkoa as get_project_10,
  get_created2khbw6a16fbfp as get_created,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemCompletionMessageFields.mjs';
import {
  get_projectzxws9pkspb0a as get_project_11,
  get_state333q9k6vwmx2f as get_state,
} from '../../../../../../crowpay-shared/com/crowpay/IncidentFields.mjs';
import {
  get_project3c9djjff48j0d as get_project_12,
  get_createdoru21mxgd9ia as get_created_0,
} from '../../../../../../crowpay-shared/com/crowpay/IncidentMessageFields.mjs';
import {
  get_project1t10doy5antl1 as get_project_13,
  get_referencesPayApp2j107w4s6lx3b as get_referencesPayApp,
  get_referencesChangeRequest3ru7mjlfmk3mg as get_referencesChangeRequest,
  get_senderfnqbuybwjyzf as get_sender,
  get_readByax5xrch6yvl3 as get_readBy,
  get_sent1fielv150x6ow as get_sent,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectMessageFields.mjs';
import {
  SetAllElements1q4mlxrpjpkix as SetAllElements,
  And3abx79zpqd7r8 as And,
  Or3lq77uaxl3wr0 as Or,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { ConstantLimitReadable29q2jwoe6byet as ConstantLimitReadable } from '../../../utils/utils.mjs';
import { get_project2fucttg0o5hjg as get_project_14 } from '../../../../../../crowpay-shared/com/crowpay/CompletionMessageCommentFields.mjs';
import { get_project1wlofjeblezw8 as get_project_15 } from '../../../../../../crowpay-shared/com/crowpay/IncidentMessageCommentFields.mjs';
import { get_projectuqhdbpbkwkr4 as get_project_16 } from '../../../../../../crowpay-shared/com/crowpay/ProjectTimerFields.mjs';
import { get_project23k9lsk7gv41f as get_project_17 } from '../../../../../../crowpay-shared/com/crowpay/ProjectSettlementDocumentationFields.mjs';
import { get_project24cljftix7ci2 as get_project_18 } from '../../../../../../crowpay-shared/com/crowpay/UnlockProjectRequestFields.mjs';
import { get_project1eezbsfxh4elg as get_project_19 } from '../../../../../../crowpay-shared/com/crowpay/FundsRequestFields.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { IncidentFlowPermissions44pkdokiuf55 as IncidentFlowPermissions } from '../../../../../../crowpay-shared/com/crowpay/incidentResponse/IncidentFlowPermissions.mjs';
import { isPendingCompletion65tdr7y6lgp6 as isPendingCompletion } from '../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  PayAppStatus_Pending_getInstance2ma8qo3my1dmm as PayAppStatus_Pending_getInstance,
} from '../../components/project/work/payApps/data.mjs';
import { ProjectView3mpzjwcpohxct as ProjectView } from './ProjectView.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ij4_1 = function_0;
      }
      wi(a, b) {
        return this.ij4_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ij4_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function AuthorizedProjectView$Data$lineItems$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o6k_1;
  var tmp$ret$1 = b.o6k_1;
  return compareValues(tmp, tmp$ret$1);
}
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(lens, projectId) {
        this.hhd_1 = lens;
        this.ihd_1 = projectId;
        var tmp = this;
        tmp.jhd_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(get_session()).pfv_1.lft(this.ihd_1));
        var tmp_0 = this;
        tmp_0.khd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.baj($this$remember.baj(this.jhd_1));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().nfx(getKClass(Project()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_1 = this;
        tmp_1.lhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).mfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp$ret$4 = eq(get_project(it), this.ihd_1);
          return tmp.kdw(new (Query())(tmp$ret$4, VOID, VOID, 10000));
        });
        var tmp_2 = this;
        tmp_2.mhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).nfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ItemChange()), arrayOf([]), false));
          var tmp$ret$6 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$6);
          var tmp$ret$8 = eq(get_project_0(it), this.ihd_1);
          var tmp$ret$9 = new (Query())(tmp$ret$8, orderBy, 0, limit);
          return tmp.kdw(tmp$ret$9);
        });
        var tmp_3 = this;
        tmp_3.nhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj($this$remember.baj(this.lhd_1));
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_0 = AuthorizedProjectView$Data$lineItems$lambda$lambda;
          // Inline function 'kotlin.comparisons.thenBy' call
          var this_0 = new (sam$kotlin_Comparator$0())(tmp_0);
          var tmp_1 = (a, b) => {
            var previousCompare = this_0.compare(a, b);
            var tmp;
            if (!(previousCompare === 0)) {
              tmp = previousCompare;
            } else {
              // Inline function 'kotlin.comparisons.compareValuesBy' call
              var tmp_0 = a.l6k_1;
              var tmp$ret$12 = b.l6k_1;
              tmp = compareValues(tmp_0, tmp$ret$12);
            }
            return tmp;
          };
          var tmp$ret$14 = new (sam$kotlin_Comparator$0())(tmp_1);
          var items = sortedWith(tmp, tmp$ret$14);
          var changes = $this$remember.baj($this$remember.baj(this.mhd_1));
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
          var _iterator__ex2g4s = items.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_0 = ArrayList().w();
            var _iterator__ex2g4s_0 = changes.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (element.a6b_1.equals(item.g6k_1)) {
                destination_0.v(element);
              }
            }
            var tmp$ret$18 = AdjustedLineItem().hfy(item, destination_0);
            destination.v(tmp$ret$18);
          }
          return destination;
        });
        var tmp_4 = this;
        tmp_4.ohd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).zfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ContractorNote()), arrayOf([]), false));
          var tmp$ret$21 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$21);
          var tmp_1 = eq(get_project_1(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(ContractorNote()), arrayOf([]), false));
          var tmp$ret$26 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$26);
          this_0.m4a(get_at(it_0));
          var tmp$ret$31 = this_0.o1r();
          return tmp.kdw(new (Query())(tmp_1, tmp$ret$31, VOID, 2147483647));
        });
        var tmp_5 = this;
        tmp_5.phd_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ohd_1)));
        var tmp_6 = this;
        tmp_6.qhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.baj(this.khd_1).c7b_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = $this$remember.baj(get_session()).ifv_1.eeo(tmp0_safe_receiver);
          }
          return tmp;
        });
        var tmp_7 = this;
        tmp_7.rhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.baj(this.qhd_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$remember.baj(tmp0_safe_receiver);
          return tmp1_elvis_lhs == null ? new (Client())(VOID, Companion_getInstance().m2p(), '', VOID, VOID, '', '', new (Address())()) : tmp1_elvis_lhs;
        });
        var tmp_8 = this;
        tmp_8.shd_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(get_session()).jfv_1.eeo($this$remember.baj(this.khd_1).z7a_1));
        var tmp_9 = this;
        tmp_9.thd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.baj($this$remember.baj(this.shd_1));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0 = new (Address())();
            var tmp_1 = new (Address())();
            // Inline function 'kotlin.collections.setOf' call
            var tmp_2 = emptySet();
            // Inline function 'kotlin.collections.listOf' call
            var tmp$ret$35 = emptyList();
            tmp = new (Contractor())(VOID, VOID, '', '', '', '', tmp_0, VOID, VOID, VOID, VOID, '', '', '', '', tmp_1, tmp_2, VOID, VOID, VOID, VOID, '', '', tmp$ret$35);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_10 = this;
        tmp_10.uhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).rfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
          var tmp$ret$36 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$36);
          var tmp_1 = eq(get_project_2(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
          var tmp$ret$41 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$41);
          this_0.m4a(get_order(it_0));
          var tmp$ret$46 = this_0.o1r();
          return tmp.kdw(new (Query())(tmp_1, tmp$ret$46, VOID, 2147483647));
        });
        var tmp_11 = this;
        tmp_11.vhd_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.uhd_1)));
        var tmp_12 = this;
        tmp_12.whd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).hfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
          var tmp$ret$47 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$47);
          var tmp_1 = eq(get_project_3(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
          var tmp$ret$52 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$52);
          this_0.m4a(get_number(it_0));
          var tmp$ret$57 = this_0.o1r();
          return tmp.kdw(new (Query())(tmp_1, tmp$ret$57, VOID, 2147483647));
        });
        var tmp_13 = this;
        tmp_13.xhd_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.whd_1)));
        var tmp_14 = this;
        tmp_14.yhd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).ffw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Dispute()), arrayOf([]), false));
          var tmp$ret$58 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$58);
          var tmp$ret$62 = eq(get_project_4(it), this.ihd_1);
          return tmp.kdw(new (Query())(tmp$ret$62, VOID, VOID, 2147483647));
        });
        var tmp_15 = this;
        tmp_15.zhd_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.yhd_1)));
        var tmp_16 = this;
        tmp_16.ahe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).ufv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
          var tmp$ret$63 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$63);
          var tmp_1 = eq(get_project_5(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
          var tmp$ret$68 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$68);
          this_0.m4a(get_order_0(it_0));
          this_0.m4a(get_scopeTitle(it_0));
          var tmp$ret$73 = this_0.o1r();
          return tmp.kdw(new (Query())(tmp_1, tmp$ret$73, VOID, 2147483647));
        });
        var tmp_17 = this;
        tmp_17.bhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ahe_1)));
        var tmp_18 = this;
        tmp_18.che_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).tfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
          var tmp$ret$75 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$75);
          var tmp$ret$77 = eq(get_project_6(it), this.ihd_1);
          var tmp$ret$78 = new (Query())(tmp$ret$77, orderBy, 0, limit);
          return tmp.kdw(tmp$ret$78);
        });
        var tmp_19 = this;
        tmp_19.dhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.che_1)));
        var tmp_20 = this;
        tmp_20.ehe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).sfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
          var tmp$ret$80 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$80);
          var tmp$ret$82 = eq(get_project_7(it), this.ihd_1);
          var tmp$ret$83 = new (Query())(tmp$ret$82, orderBy, 0, limit);
          return tmp.kdw(tmp$ret$83);
        });
        var tmp_21 = this;
        tmp_21.fhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ehe_1)));
        var tmp_22 = this;
        tmp_22.ghe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).afw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PayApplication()), arrayOf([]), false));
          var tmp$ret$84 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$84);
          var tmp_1 = eq(get_project_8(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(PayApplication()), arrayOf([]), false));
          var tmp$ret$89 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$89);
          this_0.m4a(get_number_0(it_0));
          var tmp$ret$94 = this_0.o1r();
          return tmp.kdw(new (Query())(tmp_1, tmp$ret$94, VOID, 2147483647));
        });
        var tmp_23 = this;
        tmp_23.hhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ghe_1)));
        var tmp_24 = this;
        tmp_24.ihe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).bfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PayAppItem()), arrayOf([]), false));
          var tmp$ret$95 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$95);
          var tmp_1 = eq(get_project_9(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(PayAppItem()), arrayOf([]), false));
          var tmp$ret$100 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$100);
          this_0.n4a(get_amount(it_0));
          this_0.m4a(get__id(it_0));
          var tmp$ret$105 = this_0.o1r();
          return tmp.kdw(new (Query())(tmp_1, tmp$ret$105, VOID, 2147483647));
        });
        var tmp_25 = this;
        tmp_25.jhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ihe_1)));
        var tmp_26 = this;
        tmp_26.khe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).cfw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
          var tmp$ret$106 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$106);
          var tmp1_condition = eq(get_project_10(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
          var tmp$ret$111 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$111);
          this_0.m4a(get_created(it_0));
          var tmp2_orderBy = this_0.o1r();
          return tmp.kdw(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
        });
        var tmp_27 = this;
        tmp_27.lhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.khe_1)));
        var tmp_28 = this;
        tmp_28.mhe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).gfw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Incident()), arrayOf([]), false));
          var tmp$ret$117 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$117);
          var tmp1_condition = eq(get_project_11(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Incident()), arrayOf([]), false));
          var tmp$ret$122 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$122);
          this_0.o4a(get_state(it_0));
          var tmp2_orderBy = this_0.o1r();
          return tmp.kdw(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
        });
        var tmp_29 = this;
        tmp_29.nhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.mhe_1)));
        var tmp_30 = this;
        tmp_30.ohe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).hfw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(IncidentMessage()), arrayOf([]), false));
          var tmp$ret$128 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$128);
          var tmp1_condition = eq(get_project_12(it), this.ihd_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(IncidentMessage()), arrayOf([]), false));
          var tmp$ret$133 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$133);
          this_0.m4a(get_created_0(it_0));
          var tmp2_orderBy = this_0.o1r();
          return tmp.kdw(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
        });
        var tmp_31 = this;
        tmp_31.phe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ohe_1)));
        var tmp_32 = this;
        tmp_32.qhe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var id = $this$remember.baj(get_session()).efv_1;
          var tmp0_safe_receiver = $this$remember.baj(get_rawSession());
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jfw_1;
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.lightningkite.lightningdb.condition' call
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
            var tmp$ret$139 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it = new (DataClassPathSelf())(tmp$ret$139);
            var tmp_1 = eq(get_project_13(it), this.ihd_1);
            var tmp_2 = eq(get_referencesPayApp(it), null);
            var tmp_3 = eq(get_referencesChangeRequest(it), null);
            var tmp_4 = neq(get_sender(it), id);
            // Inline function 'com.lightningkite.lightningdb.all' call
            var this_0 = get_readBy(it);
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_5 = serializerOrContextual(createKType(getKClass(UUID()), arrayOf([]), false));
            var tmp$ret$141 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_0 = new (DataClassPathSelf())(tmp$ret$141);
            var tmp$ret$144 = neq(it_0, id);
            var tmp$ret$145 = this_0.m3t(SetAllElements().w3s(tmp$ret$144));
            var tmp_6 = And().x3q([tmp_1, tmp_2, tmp_3, tmp_4, Or().a3r([tmp$ret$145])]);
            // Inline function 'com.lightningkite.lightningdb.sort' call
            // Inline function 'kotlin.apply' call
            var this_1 = new (SortBuilder())();
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_7 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
            var tmp$ret$149 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
            var it_1 = new (DataClassPathSelf())(tmp$ret$149);
            this_1.n4a(get_sent(it_1));
            var tmp$ret$154 = this_1.o1r();
            tmp = tmp1_safe_receiver.kdw(new (Query())(tmp_6, tmp$ret$154, VOID, 1));
          }
          var tmp2_elvis_lhs = tmp;
          return tmp2_elvis_lhs == null ? new (ConstantLimitReadable())(emptyList()) : tmp2_elvis_lhs;
        });
        var tmp_33 = this;
        tmp_33.rhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.qhe_1)));
        var tmp_34 = this;
        tmp_34.she_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).efw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CompletionMessageComment()), arrayOf([]), false));
          var tmp$ret$155 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$155);
          var tmp$ret$159 = eq(get_project_14(it), this.ihd_1);
          return tmp.kdw(new (Query())(tmp$ret$159, VOID, VOID, 10000));
        });
        var tmp_35 = this;
        tmp_35.the_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.she_1)));
        var tmp_36 = this;
        tmp_36.uhe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).ifw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(IncidentMessageComment()), arrayOf([]), false));
          var tmp$ret$160 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$160);
          var tmp$ret$164 = eq(get_project_15(it), this.ihd_1);
          return tmp.kdw(new (Query())(tmp$ret$164, VOID, VOID, 10000));
        });
        var tmp_37 = this;
        tmp_37.vhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.uhe_1)));
        var tmp_38 = this;
        tmp_38.whe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).dfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectTimer()), arrayOf([]), false));
          var tmp$ret$165 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$165);
          var tmp$ret$169 = eq(get_project_16(it), this.ihd_1);
          return tmp.kdw(new (Query())(tmp$ret$169, VOID, VOID, 10000));
        });
        var tmp_39 = this;
        tmp_39.xhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.whe_1)));
        var tmp_40 = this;
        tmp_40.yhe_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).mfw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectSettlementDocumentation()), arrayOf([]), false));
          var tmp$ret$171 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$171);
          var tmp$ret$173 = eq(get_project_17(it), this.ihd_1);
          var tmp$ret$174 = new (Query())(tmp$ret$173, orderBy, 0, 100);
          return tmp.kdw(tmp$ret$174);
        });
        var tmp_41 = this;
        tmp_41.zhe_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.yhe_1)));
        var tmp_42 = this;
        tmp_42.ahf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).nfw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(UnlockProjectRequest()), arrayOf([]), false));
          var tmp$ret$176 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$176);
          var tmp$ret$178 = eq(get_project_18(it), this.ihd_1);
          var tmp$ret$179 = new (Query())(tmp$ret$178, orderBy, 0, 100);
          return tmp.kdw(tmp$ret$179);
        });
        var tmp_43 = this;
        tmp_43.bhf_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.ahf_1)));
        var tmp_44 = this;
        tmp_44.chf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).ofw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(FundsRequest()), arrayOf([]), false));
          var tmp$ret$181 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$181);
          var tmp$ret$183 = eq(get_project_19(it), this.ihd_1);
          var tmp$ret$184 = new (Query())(tmp$ret$183, orderBy, 0, 100);
          return tmp.kdw(tmp$ret$184);
        });
        var tmp_45 = this;
        tmp_45.dhf_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.chf_1)));
        var tmp_46 = this;
        tmp_46.ehf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.baj(this.khd_1);
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.bhf_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.n86_1.equals(p.j7c_1)) {
              destination.v(element);
            }
          }
          var tmp$ret$188;
          $l$block_0: {
            // Inline function 'kotlin.collections.maxByOrNull' call
            var iterator = destination.m1();
            if (!iterator.n1()) {
              tmp$ret$188 = null;
              break $l$block_0;
            }
            var maxElem = iterator.o1();
            if (!iterator.n1()) {
              tmp$ret$188 = maxElem;
              break $l$block_0;
            }
            var maxValue = maxElem.o86_1.q54_1;
            do {
              var e = iterator.o1();
              var v = e.o86_1.q54_1;
              if (compareTo(maxValue, v) < 0) {
                maxElem = e;
                maxValue = v;
              }
            }
             while (iterator.n1());
            tmp$ret$188 = maxElem;
          }
          return tmp$ret$188;
        });
        var tmp_47 = this;
        tmp_47.fhf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.baj(this.khd_1);
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.baj(this.lhe_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.a6h_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          var messages = destination;
          // Inline function 'kotlin.collections.associate' call
          var this_0 = $this$remember.baj(this.nhd_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination_0 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_0 = this_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp_0 = this.hhd_1.xgj();
            var tmp0_safe_receiver = $this$remember.baj(get_rawSession());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.baj(tmp0_safe_receiver.pfw_1);
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m88_1;
            var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j8c_1;
            var tmp3_elvis_lhs = messages.p3(element_0.kf9_1);
            // Inline function 'kotlin.collections.plusAssign' call
            var pair = to(element_0.kf9_1, new (CompletionFlowPermissions())(element_0.hf9_1, tmp_0, tmp_1, tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs, p.h7c_1));
            destination_0.s3(pair.af_1, pair.bf_1);
          }
          return destination_0;
        });
        var tmp_48 = this;
        tmp_48.ghf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.baj(this.khd_1);
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.baj(this.phe_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.x67_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          var messages = destination;
          // Inline function 'kotlin.collections.associate' call
          var this_0 = $this$remember.baj(this.nhe_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination_0 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_0 = this_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp0_elvis_lhs = messages.p3(element_0.d63_1);
            var tmp_0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var tmp_1 = this.hhd_1.xgj();
            var tmp1_safe_receiver = $this$remember.baj(get_rawSession());
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : $this$remember.baj(tmp1_safe_receiver.pfw_1);
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.m88_1;
            // Inline function 'kotlin.collections.plusAssign' call
            var pair = to(element_0.d63_1, new (IncidentFlowPermissions())(p, element_0, tmp_0, tmp_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.j8c_1));
            destination_0.s3(pair.af_1, pair.bf_1);
          }
          return destination_0;
        });
        var tmp_49 = this;
        tmp_49.hhf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.baj(this.khd_1);
          var draws = $this$remember.baj(this.jhe_1);
          var items = $this$remember.baj(this.nhd_1);
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = items.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (isPendingCompletion(element.kfy())) {
              destination.v(element);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp = sum;
            var tmp$ret$212 = element_0.hf9_1.o91();
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$212);
          }
          var workPending = sum;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_1 = draws.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            if (get_status(element_1).equals(PayAppStatus_Pending_getInstance())) {
              destination_0.v(element_1);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum_0 = Companion_instance.p91(0n);
          var _iterator__ex2g4s_2 = destination_0.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            var tmp_0 = sum_0;
            var tmp$ret$217 = element_2.t6v_1;
            sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$217);
          }
          var drawsPending = sum_0;
          return new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(p.s97(), workPending), drawsPending));
        });
      }
      jf8() {
        return this.ihd_1;
      }
      jfy() {
        return this.khd_1;
      }
      tgm() {
        return this.nhd_1;
      }
      xgz() {
        return this.phd_1;
      }
      wgk() {
        return this.rhd_1;
      }
      fgl() {
        return this.thd_1;
      }
      ugm() {
        return this.vhd_1;
      }
      vgv() {
        return this.xhd_1;
      }
      lgy() {
        return this.bhe_1;
      }
      igt() {
        return this.dhe_1;
      }
      jgt() {
        return this.fhe_1;
      }
      hgt() {
        return this.jhe_1;
      }
      bgt() {
        return this.lhe_1;
      }
      egt() {
        return this.the_1;
      }
      ngf() {
        return this.xhe_1;
      }
      oh2() {
        return this.zhe_1;
      }
      mgf() {
        return this.fhf_1;
      }
      sh2() {
        return this.hhf_1;
      }
      toString() {
        return 'Data(lens=' + this.hhd_1.toString() + ', projectId=' + this.ihd_1.toString() + ')';
      }
      hashCode() {
        var result = this.hhd_1.hashCode();
        result = imul(result, 31) + this.ihd_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!this.hhd_1.equals(other.hhd_1))
          return false;
        if (!this.ihd_1.equals(other.ihd_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data');
    DataClass = $;
  }
  return DataClass;
}
var AuthorizedProjectViewClass;
function AuthorizedProjectView() {
  if (AuthorizedProjectViewClass === VOID) {
    class $ extends ProjectView() {
      constructor(lens, projectId) {
        super(lens);
        this.if8_1 = new (Data())(lens, projectId);
      }
      jf8() {
        return this.if8_1.ihd_1;
      }
      jfy() {
        return this.if8_1.khd_1;
      }
      tgm() {
        return this.if8_1.nhd_1;
      }
      xgz() {
        return this.if8_1.phd_1;
      }
      wgk() {
        return this.if8_1.rhd_1;
      }
      fgl() {
        return this.if8_1.thd_1;
      }
      ugm() {
        return this.if8_1.vhd_1;
      }
      vgv() {
        return this.if8_1.xhd_1;
      }
      kgz() {
        return this.if8_1.zhd_1;
      }
      lgy() {
        return this.if8_1.bhe_1;
      }
      igt() {
        return this.if8_1.dhe_1;
      }
      jgt() {
        return this.if8_1.fhe_1;
      }
      dgt() {
        return this.if8_1.hhe_1;
      }
      hgt() {
        return this.if8_1.jhe_1;
      }
      bgt() {
        return this.if8_1.lhe_1;
      }
      ggt() {
        return this.if8_1.nhe_1;
      }
      cgt() {
        return this.if8_1.phe_1;
      }
      ij3() {
        return this.if8_1.rhe_1;
      }
      egt() {
        return this.if8_1.the_1;
      }
      fgt() {
        return this.if8_1.vhe_1;
      }
      ngf() {
        return this.if8_1.xhe_1;
      }
      oh2() {
        return this.if8_1.zhe_1;
      }
      jj3() {
        return this.if8_1.bhf_1;
      }
      tgj() {
        return this.if8_1.dhf_1;
      }
      mgf() {
        return this.if8_1.fhf_1;
      }
      rgt() {
        return this.if8_1.ghf_1;
      }
      ugj() {
        return this.if8_1.ehf_1;
      }
      sh2() {
        return this.if8_1.hhf_1;
      }
    }
    initMetadataForClass($, 'AuthorizedProjectView', VOID, VOID, VOID, [1]);
    AuthorizedProjectViewClass = $;
  }
  return AuthorizedProjectViewClass;
}
//region block: exports
export {
  Data as Data3qblafqxenieu,
  AuthorizedProjectView as AuthorizedProjectView36p4bgamz7ogy,
};
//endregion

//# sourceMappingURL=AuthorizedProjectView.mjs.map
